import { provideIcons } from '@ng-icons/core';
import {
  phosphorEyeBold,
  phosphorUserBold,
  phosphorWarningBold,
  phosphorXBold,
} from '@ng-icons/phosphor-icons/bold';
import {
  phosphorCaretDownFill,
  phosphorCaretUpFill,
  phosphorCheckCircleFill,
} from '@ng-icons/phosphor-icons/fill';
import {
  phosphorAddressBook,
  phosphorArchive,
  phosphorArrowClockwise,
  phosphorArrowFatLineUp,
  phosphorArrowRight,
  phosphorBank,
  phosphorBell,
  phosphorBriefcase,
  phosphorBuildingOffice,
  phosphorCalendarBlank,
  phosphorCalendarDots,
  phosphorCardsThree,
  phosphorCaretDown,
  phosphorCaretLeft,
  phosphorCaretRight,
  phosphorCaretUp,
  phosphorCertificate,
  phosphorChartBar,
  phosphorChartDonut,
  phosphorChartLine,
  phosphorChartLineUp,
  phosphorChartPieSlice,
  phosphorCheck,
  phosphorCheckCircle,
  phosphorCheckSquareOffset,
  phosphorCheckerboard,
  phosphorClipboardText,
  phosphorClock,
  phosphorClockCounterClockwise,
  phosphorCopy,
  phosphorCube,
  phosphorCurrencyCircleDollar,
  phosphorCurrencyDollar,
  phosphorCurrencyDollarSimple,
  phosphorCursorClick,
  phosphorDownloadSimple,
  phosphorEnvelopeSimple,
  phosphorExclamationMark,
  phosphorEye,
  phosphorEyeClosed,
  phosphorFile,
  phosphorFilePdf,
  phosphorFileText,
  phosphorFileXls,
  phosphorFolder,
  phosphorFolderOpen,
  phosphorFunnelSimple,
  phosphorHandArrowDown,
  phosphorHandDeposit,
  phosphorHandWithdraw,
  phosphorHardDrives,
  phosphorImage,
  phosphorInfo,
  phosphorKeyReturn,
  phosphorList,
  phosphorListChecks,
  phosphorListMagnifyingGlass,
  phosphorLockSimple,
  phosphorMagnifyingGlass,
  phosphorPencilSimple,
  phosphorPlayCircle,
  phosphorPlus,
  phosphorPlusCircle,
  phosphorQuestion,
  phosphorScales,
  phosphorSignOut,
  phosphorSquaresFour,
  phosphorStack,
  phosphorStackSimple,
  phosphorSuitcaseSimple,
  phosphorTable,
  phosphorTrash,
  phosphorTrashSimple,
  phosphorTreeStructure,
  phosphorUploadSimple,
  phosphorUser,
  phosphorUserCircleGear,
  phosphorUsersThree,
  phosphorWarning,
  phosphorWarningCircle,
  phosphorWarningOctagon,
  phosphorWaveSquare,
  phosphorX,
  phosphorXCircle,
} from '@ng-icons/phosphor-icons/regular';

import { phosphorCalendarMoney } from '@assets/images/icons/phosphorCalendarMoney';
import { phosphorEyeFocus } from '@assets/images/icons/phosphorEyeFocus';
import { phosphorFileCog } from '@assets/images/icons/phosphorFileCog';
import { phosphorFileMoney } from '@assets/images/icons/phosphorFileMoney';
import { phosphorFileXLSX } from '@assets/images/icons/phosphorFileXLSX';
import { phosphorFileXML } from '@assets/images/icons/phosphorFileXML';
import { phosphorStepsSquare } from '@assets/images/icons/phosphorStepsSquare';
import { phosphorVerifiedSearch } from '@assets/images/icons/phosphorVerifiedSearch';

const regularIcons = {
  phosphorPlayCircle,
  phosphorClockCounterClockwise,
  phosphorClipboardText,
  phosphorPencilSimple,
  phosphorUser,
  phosphorCalendarBlank,
  phosphorCopy,
  phosphorCurrencyDollar,
  phosphorBriefcase,
  phosphorHandWithdraw,
  phosphorHandDeposit,
  phosphorCardsThree,
  phosphorCaretDown,
  phosphorCaretRight,
  phosphorCaretUp,
  phosphorInfo,
  phosphorQuestion,
  phosphorChartLineUp,
  phosphorHandArrowDown,
  phosphorBank,
  phosphorScales,
  phosphorMagnifyingGlass,
  phosphorFilePdf,
  phosphorFileXls,
  phosphorFile,
  phosphorDownloadSimple,
  phosphorCheckCircle,
  phosphorWarning,
  phosphorClock,
  phosphorWarningOctagon,
  phosphorLockSimple,
  phosphorEye,
  phosphorEyeClosed,
  phosphorEnvelopeSimple,
  phosphorArrowFatLineUp,
  phosphorX,
  phosphorXCircle,
  phosphorKeyReturn,
  phosphorPlusCircle,
  phosphorPlus,
  phosphorSquaresFour,
  phosphorCaretLeft,
  phosphorBell,
  phosphorSignOut,
  phosphorListChecks,
  phosphorCube,
  phosphorList,
  phosphorArchive,
  phosphorAddressBook,
  phosphorSuitcaseSimple,
  phosphorChartLine,
  phosphorListMagnifyingGlass,
  phosphorCheckerboard,
  phosphorCalendarDots,
  phosphorCurrencyDollarSimple,
  phosphorFunnelSimple,
  phosphorBuildingOffice,
  phosphorWarningCircle,
  phosphorArrowClockwise,
  phosphorCurrencyCircleDollar,
  phosphorCheckSquareOffset,
  phosphorTable,
  phosphorChartPieSlice,
  phosphorChartBar,
  phosphorChartDonut,
  phosphorTreeStructure,
  phosphorWaveSquare,
  phosphorHardDrives,
  phosphorUserCircleGear,
  phosphorCertificate,
  phosphorExclamationMark,
  phosphorCheck,
  phosphorFolderOpen,
  phosphorFolder,
  phosphorFileText,
  phosphorImage,
  phosphorUploadSimple,
  phosphorTrash,
  phosphorTrashSimple,
  phosphorArrowRight,
  phosphorCursorClick,
  phosphorStackSimple,
  // LEN-2363: the Overview's priority position and master servicer cuts.
  phosphorStack,
  phosphorUsersThree,
};

const boldIcons = {
  phosphorUserBold,
  phosphorEyeBold,
  phosphorXBold,
  phosphorWarningBold,
  phosphorCalendarMoney,
};
const fillIcons = {
  phosphorCaretDownFill,
  phosphorCaretUpFill,
  phosphorCheckCircleFill,
};

const customIcons = {
  phosphorFileXLSX,
  phosphorFileXML,
  phosphorVerifiedSearch,
  phosphorEyeFocus,
  phosphorFileMoney,
  phosphorFileCog,
  phosphorStepsSquare,
};

export const iconProvider = provideIcons({
  ...regularIcons,
  ...boldIcons,
  ...fillIcons,
  ...customIcons,
});
